import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetSubNavigationQuery } from '../../../libs/graphql/betzoneDirectusAPI/queries/__generated__/get-sub-nav.query.generated';
import { Endpoint } from '../../../models/api.model';
import { locale } from '../../../consts';
import { AvailableBrands } from '../../../components/Itv/types';

export const useFirstSubNavItem = (brand: AvailableBrands): string | undefined => {
  const { subpage } = useParams();
  const [effectiveSubpage, setEffectiveSubpage] = useState<string | undefined>(subpage);

  const { data: subNavigation } = useGetSubNavigationQuery({
    variables: { language: locale },
    context: { endpoint: Endpoint.betzoneDirectusAPI },
  });

  // Set the effective subpage to first item when no subpage is provided
  useEffect(() => {
    // If we have a subpage parameter, use it
    if (subpage) {
      setEffectiveSubpage(subpage);

      return;
    }

    // If no subpage and we have subNavigation data, use the first item
    if (subNavigation?.[brand]) {
      const [firstItemData] = subNavigation[brand];
      const [firstItem] = firstItemData?.translations ?? [];

      if (firstItem?.slug) {
        setEffectiveSubpage(firstItem.slug);
      }
    }
  }, [subpage, subNavigation, brand]);

  return effectiveSubpage;
};
